var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.comp},[_vm._v("\n  "+_vm._s(_vm.$t('random_call_direct_call'))+"\n  "+_vm._s(_vm.$t('introductory_price_for_300_coins'))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }